import React from 'react'
import parser from 'html-react-parser'
import WeMust from 'components/Home/WeMust'
import WeMustBuilder from 'components/Home/WeMustBuilder'

export default function Imagine({data}) {
    const {imagineTitle, imagineSlides} = data
    return (
        <div className='wemust-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h2 className='lg-font-140'>{imagineTitle && parser(imagineTitle)}</h2>
                    </div>
                    <div className='col-md-12'>
                        <WeMustBuilder imagineHomeSlides={imagineSlides} />
                    </div>
                </div>
            </div>
        </div>
    )
}
